import { createSlice, PayloadAction } from '@reduxjs/toolkit'

import { TOAST_AFTER_EVENT } from '@Root/contants/myhouseToast'

interface ToastState {
  isShow: boolean
  message: string
  afterEvent: TOAST_AFTER_EVENT
  path: string
  /*무료보험 프로모션 추가부분 시작*/
  isPromotion: boolean
  /*무료보험 프로모션 추가부분 끝*/
}

const initialState: ToastState = {
  isShow: false,
  message: '',
  afterEvent: TOAST_AFTER_EVENT.NONE,
  path: '',
  isPromotion: false,
} as ToastState

const toastSlice = createSlice({
  name: 'myhouseToast',
  initialState,
  reducers: {
    updateIsShow: (state: ToastState, action: PayloadAction<boolean>) => {
      state.isShow = action.payload
    },
    updateMessage: (state: ToastState, action: PayloadAction<string>) => {
      state.message = action.payload
    },
    updateAfterEvent: (state: ToastState, action: PayloadAction<TOAST_AFTER_EVENT>) => {
      state.afterEvent = action.payload
    },
    updateAfterPath: (state: ToastState, action: PayloadAction<string>) => {
      state.path = action.payload
    },
    updateIsPromotion: (state: ToastState, action: PayloadAction<boolean>) => {
      state.isPromotion = action.payload
    },
  },
  extraReducers: {},
})

export const { updateIsShow, updateMessage, updateAfterEvent, updateAfterPath, updateIsPromotion } = toastSlice.actions
export default toastSlice.reducer
